import dayjs from 'dayjs';
import dayOfYear from 'dayjs/plugin/dayOfYear';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import auLocale from 'dayjs/locale/en-au'

dayjs.extend(dayOfYear);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);
dayjs.locale({ ...auLocale });


export const getSydneyDate = (date: Date | number | string = new Date()) => {
  return dayjs(date).tz(TIMEZONES.SYDNEY);
}
export enum TIMEZONES {
  SYDNEY = 'Australia/Sydney'
}

export const durationToSeconds = (duration: string): number | undefined => {
  const trimmed = duration.trim();

  if (!trimmed) {
    return 0;
  }

  if (/^\d+$/.test(trimmed)) {
    return 0;
  }

  const matches = trimmed.match(/^(?:(\d+)\s*h)?\s*(?:(\d+)\s*m)?\s*$/);
  if (!matches) {
    return undefined;
  }

  const hours = matches[1] ? parseInt(matches[1], 10) : 0;
  const minutes = matches[2] ? parseInt(matches[2], 10) : 0;

  return (hours * 3600) + (minutes * 60);
}
